<!--修改成绩-->
<template lang="pug">
    el-dialog(title="修改成绩", width="60%", :visible.sync='visible' :append-to-body="true" @close="closeForm()")
      el-form(:model='dataForm',  :rules='rules', ref='dataForm', label-suffix=":" label-width="200px" class='chose')
          el-form-item(:label="name1==null?'-':name1+'得分'" prop="firstGainScore")
              el-input-number(v-model="dataForm.firstGainScore"   :min="0"   style='margin-left:50px;')
          el-form-item(:label="name2==null?'-':name2+'得分'" prop="secondGainScore")
              el-input-number(v-model="dataForm.secondGainScore" :min="0" :max="100000000" style='margin-left:50px;')
          //- font.font_later {{name1}}让{{name1}} 0.5分
      span.dialog-footer(slot="footer")
          el-button(type="primary" @click='ReviseGrade' :loading="ishowbtn") 确 定
          el-button(@click="closeForm()") 取 消
</template>
<script>
export default {
  name: 'UpdateGrade',
  data () {
    return {
      ishowbtn: false,
      visible: false,
      name1: '',
      name2: '',
      reviseFlag: -1,
      dataForm: {
        // againstId: '',
        firstGainScore: '',
        firstSignNum: 1,
        secondGainScore: '',
        secondSignNum: 2
      },
      choseNumber: 0,
      id: '',
      rules: {
        firstGainScore: [
          { required: true, message: '成绩不能为空!', trigger: 'change' }
        ],
        secondGainScore: [
          { required: true, message: '成绩不能为空!', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init (id, rwo, rwo1, type) {
      console.log(id)
      console.log(rwo)
      console.log(rwo1)
      console.log(type)
      if (type == 1) {
      } else {
      }
      this.visible = true
      this.id = rwo.againstId
      // this.dataForm.againstId = rwo.againstId
      this.dataForm.firstGainScore = rwo.signNumScore == null ? undefined : rwo.signNumScore
      this.dataForm.secondGainScore = rwo1.signNumScore == null ? undefined : rwo1.signNumScore
      this.dataForm.firstSignNum = rwo.signNum * 1
      this.dataForm.secondSignNum = rwo1.signNum * 1
      this.name1 = rwo.name
      this.name2 = rwo1.name
      this.reviseFlag = -1
      if (this.dataForm.firstGainScore != undefined && this.dataForm.secondGainScore != undefined) {  
        this.reviseFlag = 1
        if (rwo.signNumScore < rwo1.signNumScore) {
          this.reviseFlag = 0
        }
      }        
    },
    ReviseGrade () {
      // if (this.dataForm.firstGainScore == undefined || this.dataForm.secondGainScore == undefined) {
      //   return this.$message.error('分数不能为空！')
      // }
      // if (this.dataForm.firstGainScore === this.dataForm.secondGainScore) {
      //   return this.$message.error('分数不可相同！')
      // }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.firstGainScore == undefined || this.dataForm.secondGainScore == undefined) {
            return this.$message.error('分数不能为空！')
          }
          if (this.dataForm.firstGainScore === this.dataForm.secondGainScore) {
            return this.$message.error('分数不可相同！')
          }
          let rFlag = false
          if (this.reviseFlag > -1) {
            if ((this.reviseFlag == 1 && (this.dataForm.firstGainScore < this.dataForm.secondGainScore)) ||
              (this.reviseFlag == 0 && (this.dataForm.firstGainScore > this.dataForm.secondGainScore))) {
                  const h = this.$createElement
                  this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                      h('p', '修改当前成绩已经更改胜负关系，'),
                      h('p', '后续选手对阵会被清空，'),
                      h('p', '烦请仔细核对并且确认风险。')
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',    
                    customClass: 'custom-msgbox',  
                    type: 'warning'
                  })
                    .then(() => {
                      this.ReviseGradeReq()                 
                    })
            } else {
              rFlag = true 
            }
          } else {
              rFlag = true 
          }
          if (rFlag) {          
            this.ReviseGradeReq()
          }
        }
      })
    },
    ReviseGradeReq () {
      this.ishowbtn = true
      this.$http({
        url: this.$http.adornUrl(
          `/ctCompetition/grade/achievement-manage/achievement-info/` + this.id
        ),
        method: 'PUT',
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.ishowbtn = false
              this.$emit('refreshList')
            }
          })
        } else {
          this.ishowbtn = false
          // this.$message.error('添加失败!')
        }
      })      
    },    
    closeForm () {
      this.visible = false
    }
  }
}
</script>
<style>
/* .fromlist{
  position: relative;
  height: 200px;
} */
.chose {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-top: 50px;
  padding-left: 25%; */
}
.custom-msgbox .el-button{
    background-color: rgb(2,185,13); 
    border-color: rgb(2,185,13); 
    color: white; 
}
.custom-msgbox .el-button--primary {
  margin-right: 10px;
  float:left;
  background-color: white;
  border-color:grey;
  color: black;
}
</style>
